import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '~environment';
import { Customer } from '~move-device/models/customer';
import { MoveDevice } from '~move-device/models/move-device';

@Injectable({
  providedIn: 'root'
})
export class MoveDeviceService {
    private readonly http = inject(HttpClient);
    private readonly url: string = environment.serverBaseUrl + 'device';

    getCustomers(): Observable<Customer[]> {
        return this.http.get<Customer[]>(this.url + `/customers`);
    }

    MoveDevice(command: MoveDevice): Observable<void> {
        return this.http.post<void>(this.url, command);
    }
}
